export { default } from './FormerTrainees';
